import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {PageCollection} from '@simpli/resource-collection'
import {Global} from '@/model/resource/Global'

@HttpExclude()
export class GlobalCollection extends PageCollection<Global> {
  resource?: IGlobalCollectionResourcesHolder
  @RequestExpose() minDappImageDimension: number | null = null
  @RequestExpose() maxDappImageDimension: number | null = null
  @RequestExpose() minBoostedDappMaxsize: number | null = null
  @RequestExpose() maxBoostedDappMaxsize: number | null = null
  @RequestExpose() minMinDappTransactionCountForTrending: number | null = null
  @RequestExpose() maxMinDappTransactionCountForTrending: number | null = null

  constructor() {
    super(Global)
  }

  queryAsPage() {
    return this.listGlobal()
  }

  async listGlobal() {
    return await Request.get(`/client/global`, {params: this.params})
      .name('listGlobal')
      .as(this)
      .getResponse()
  }

  async listExportGlobal() {
    return await Request.get(`/client/global/export`, {params: this.params})
      .name('listExportGlobal')
      .as(this)
      .getResponse()
  }
}

export interface IGlobalCollectionResourcesHolder {}
